import { render, staticRenderFns } from "./fwModel.vue?vue&type=template&id=5d4082cf&scoped=true"
import script from "./fwModel.vue?vue&type=script&lang=js"
export * from "./fwModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4082cf",
  null
  
)

export default component.exports